import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const App = () => import(/*webpackChunkName: 'App'*/'./App')
const HomePage = () => import(/*webpackChunkName: 'Home'*/'./views/Home')
const SignIn = () => import(/*webpackChunkName: 'SignIn'*/'./components/SignIn')
const BalanceManage = () => import(/*webpackChunkName: 'UsdtManagement'*/'./components/BalanceManage.vue')
const SubscribeManage = () => import(/*webpackChunkName: 'UsdtManagement'*/'./components/SubscribeManage.vue')
const StatisticDashboard = () => import(/*webpackChunkName: 'Statistic'*/'./components/StatisticDashboard.vue')
const UsageManager = () => import(/*webpackChunkName: 'Usage'*/'./components/UserManager.vue')
const CohortAnalysis = () => import(/*webpackChunkName: 'Cohort'*/'./components/CohortAnalysis.vue')
const UserScore = () => import(/*webpackChunkName: 'UserScore'*/'./components/UserScore.vue')
const NodeList = () => import(/*webpackChunkName: 'NodeManage'*/'./views/node/NodeList.vue')
const NodeGroupList = () => import(/*webpackChunkName: 'NodeManage'*/'./views/node/NodeGroupList.vue')
const NodeRouteList = () => import(/*webpackChunkName: 'NodeManage'*/'./views/node/NodeRouteList.vue')
const SandboxAutomation = () => import(/*webpackChunkName: 'SandboxAutomation'*/'./views/node/SandboxAutomation.vue')
const NodeAccessUserList = () => import(/*webpackChunkName: 'NodeManage'*/'./views/node/NodeAccessUserList.vue')


const routes = [
    {
        path: '/',
        name: 'root',
        component: App,
        redirect: 'home',
        children: [
            {
                path: 'signin',
                name: 'signin',
                component: SignIn,
            },
            {
                path: '',
                name: 'home',
                component: HomePage,
                beforeEnter: (to, from, next) => {
                    if (localStorage.getItem('ccToken') === null){
                        next(`signin`);
                    }
                    next();
                },
                redirect: 'statistic',
                children: [
                    {path: 'subscribe', name: 'subscribe', component: SubscribeManage},
                    {path: 'balance', name: 'balance', component: BalanceManage},
                    {path: 'statistic', name: 'statistic', component: StatisticDashboard},
                    {path: 'usage', name: 'usage', component: UsageManager},
                    {path: 'user-score', name: 'userScore', component: UserScore},
                    {path: 'cohort', name: 'cohort', component: CohortAnalysis},
                    {path: 'nodes', name: 'nodes', component: NodeList},
                    {path: 'node-groups', name: 'nodeGroups', component: NodeGroupList},
                    {path: 'node-routes', name: 'nodeRoutes', component: NodeRouteList},
                    {path: 'nodes/sandbox-automation', name: 'sandboxAutomation', component: SandboxAutomation},
                    {path: 'nodes/access-users', name: 'nodeAccessUsers', component: NodeAccessUserList},
                ]
            },
        ]
    }

]
const router = new VueRouter({
    mode: 'history',
    routes: routes
})

router.beforeEach((to, from, next) => {
    if (to.name == 'home' && localStorage.getItem('ccToken') === null) {
        next(`signin`);
    }
    next()
})

export default router
